import styled from "@emotion/styled";
import { TableCell, tableCellClasses } from "@mui/material";
import localTheme from "../theme/theme";

const StyledTableCell = styled(TableCell)(({ theme }:any) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: localTheme.colors.primary,
    color: theme.palette.common.white,
    // border: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // border: 0,
  },
}));

export default StyledTableCell;
